/** Payment cycle selection options. */
export const paymentCycleOptions: ZephyrWeb.OptionItem<number>[] = [
  { text: '15', value: 15 },
  { text: '30', value: 30 },
];
